module.exports = __webpack_public_path__ + "static/img/team-share-popup.36ceb98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thirdAnniversary/popup/team-share-popup.png
// module id = LXF2
// module chunks = 2